import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'

import Answer from './answer'
import styles from './styles.css'
import Icon from '_components/icon'
import Slider from '_components/slider'
import FormElement from '_components/formElement'
import FormBody from '_components/formBody'

import CategoryTabBodySwipe from '../categoryTabBodySwipe'

import { updateLastActivityAt } from '_modules/user/actions'
import { createEngagementEntry } from '_modules/engagement/actions'

const mapStateToProps = ({ currentTask }) => ({ currentTask })

const mapDispatchToProps = {
  updateLastActivityAt,
  createEngagementEntry,
}

class EngagementForm extends PureComponent {
  static propTypes = {
    currentTask: ImmutableProptypes.map,
    closePlusForm: PropTypes.func.isRequired,
    updateLastActivityAt: PropTypes.func.isRequired,
    createEngagementEntry: PropTypes.func.isRequired,
    currentTaskLogEntry: PropTypes.string.isRequired,
    displayError: PropTypes.func.isRequired,
  }

  static defaultProps = {
    currentTask: new Map(),
    currentTaskLogEntry: '',
  }

  state = {
    reflection: '',
    rank: 3,
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      currentTaskLogEntry: nextProps.currentTask.get('logEntry'),
    })
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown = event => {
    if (event.key === 'Enter') {
      this.onSave()
    }
  }
  onChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  onSave = () => {
    const { rank: engagementLevel, reflection } = this.state

    // if (!engagementLevel || !reflection) {
    //   this.props.displayError('Missing Reflection')
    //   return
    // }

    const { currentTask } = this.props

    if (currentTask.get('logEntry')) {
      const payload = {
        logEntry: currentTask.get('logEntry'),
        engagementLevel,
        reflection,
      }
      this.props.createEngagementEntry(payload)
      this.props.updateLastActivityAt({
        lastActivityAt: new Date(),
      })
      this.resetPlusForm()
      this.props.closePlusForm()
    } else {
      this.props.displayError('No Task In Progress')
    }
  }

  onCancel = () => {
    this.props.closePlusForm()
  }

  resetPlusForm = () => {
    this.setState({
      reflection: '',
      rank: 0,
    })
  }

  render() {
    const { rank, reflection } = this.state
    const { currentTask } = this.props
    const taskName = currentTask.get('name')

    const buttons = [
      { label: 'Save', onClick: this.onSave },
      { label: 'Cancel', onClick: this.onCancel },
    ]
    return (
      <CategoryTabBodySwipe question="Learn more here!" answer={<Answer />}>
        {taskName ? (
          <FormBody buttons={buttons}>
            {taskName && (
              <FormElement label="Task" elementContainerStyle={{ textAlign: 'left' }}>
                <span style={{ fontSize: 16, color: 'white' }}>{taskName}</span>
              </FormElement>
            )}
            <FormElement label="Rank">
              <Slider
                min={1}
                max={5}
                value={rank}
                onChange={rank => this.setState({ rank })}
                color="#F0A366"
              />
            </FormElement>
            <FormElement label="Reflection" labelStyle={{ alignSelf: 'flex-start' }}>
              <textarea
                id="reflection"
                rows="6"
                value={reflection}
                className={classnames(styles['form-textarea'])}
                onChange={this.onChange}
              />
            </FormElement>
          </FormBody>
        ) : (
          <div style={{ flexDirection: 'column', width: '100%' }}>
            <div style={{ alignSelf: 'center', fontSize: 20, color: 'white' }}>
              Start a Task to Track Engagement
            </div>
          </div>
        )}
      </CategoryTabBodySwipe>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EngagementForm)



// WEBPACK FOOTER //
// ./src/components/categoryTabs/engagementForm/index.js